<template>
  <div class="model-widget" :class="{ 'active': $store.state.editor.subId === modelId, 'disabled': !$store.state.editor.editMode }" @click="handleSelect">
    <div class="widget-tag absolute top-0 right-0 px-2 py-1 text-white z-20 rounded-bl">
      {{ $t(`model.${menuInfo.title}`) }}
    </div>
    <slot />
  </div>
</template>


<script>
import { sleep } from '~/utils'

export default {
  name: 'ModelWrapper',
  props: {
    model: {
      type: Object,
      default() {
        return {}
      }
    },
    parentModel: {
      type: Object,
      default() {
        return {}
      }
    },
    modelIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {}
  },
  computed: {
    menuInfo() {
      return this.model?.getMenuInfo() || {}
    },
    modelId() {
      return this.model.__id || this.model.id
    }
  },
  methods: {
    async handleSelect() {
      await sleep(0)
      this.parentModel.__onMenuSelected && this.parentModel.__onMenuSelected({ child: this.model }, this)
      this.$store.commit('editor/SET_SUB_ID', this.modelId)
      const menu = {
        key: this.menuInfo.title,
        target: this.model,
        config: {
          childIndex: this.modelIndex
        },
        model: this.parentModel
      }
      this.SiteMenu.open(menu)
    }
  }
}
</script>

<style lang="less">
.model-widget {
  border: 1px dashed transparent;
  position: relative;
  &.disabled {
    border: none !important;
    .widget-tag {
      display: none !important;
    }
  }
  .widget-tag {
    background-color: rgba(245, 63, 63, 0.7);
    display: none;
  }
  &:hover {
    border: 1px dashed @error-color;
    .widget-tag {
      display: block;
    }
  }
  &.active {
    border: 1px dashed @error-color;
    .widget-tag {
      display: block;
    }
  }
}
</style>
